import React from 'react';
import { observer } from 'mobx-react';
import GroupOfBlocksHTML from './groupOfBlocksHTML';

export const GroupOfBlocks = observer(({ ui, handleChange, value, answer }) => {
    return (
        <GroupOfBlocksHTML
            ui={ui}
            handleChange={handleChange}
            value={value}
            answer={answer}
        />
    );
});
